/**
 * A estrela do CosmosAI.
 *
 * O protótipo usa uma única estrela de quatro pontas para a marca da IA, em
 * dois acabamentos: preenchida no símbolo (`zChatAiMark`, `.ai-spark`) e de
 * traço na trilha de avisos (`cwIcons.ai`). O sparkle de três estrelas do
 * lucide é outro símbolo — `docs/DESIGN.md` proíbe a troca em voz alta —,
 * então o desenho vem daqui e não da biblioteca.
 */
export function CosmosAiIcon({
  size = 16,
  variant = "filled",
  className,
}: {
  size?: number;
  variant?: "filled" | "outline";
  className?: string;
}) {
  const filled = variant === "filled";
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={filled ? undefined : 1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={
          filled
            ? "M12 2l2.2 6.6L21 11l-6.8 2.4L12 20l-2.2-6.6L3 11l6.8-2.4z"
            : "m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z"
        }
      />
    </svg>
  );
}
